module.exports = __webpack_public_path__ + "static/media/danger.a849e4e4.svg";